const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"KN6LRldl7PhXRrG_TVYGt"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["till-next-gen-mvp@till-payments"]={id:"KN6LRldl7PhXRrG_TVYGt"};
      